import styled from 'styled-components'
import ExchangeIcon from '@pc/components/Works/Panel/shared/Icons/ExchangeIcon'

const EtcSelectPanelUpdateIconBase = styled(ExchangeIcon)`
  color: #457ab5;
  margin-left: 4px;
`

const EtcSelectPanelUpdateIcon = () => <EtcSelectPanelUpdateIconBase width="14px" height="14px" />

export default EtcSelectPanelUpdateIcon
